export default __webpack_public_path__ + "static/media/5.1f1fbd97.png";